import { createRoot } from "react-dom/client";
import { allTrackers } from "../../../services/track/track";
import { ListSettingsModal } from "./ListSettingsModal";
import type {
    IListSettings,
    IOpportunityListItem,
    IOpportunityListItemTrackStatus,
    IOpportunityUpdateInfo,
} from "./types";
import { WatchListModal } from "./WatchListModal";

export const editListModal = (props = {} as IListSettings): Promise<IOpportunityUpdateInfo> => {
    const domEl = document.createElement("div");
    document.body.appendChild(domEl);
    const root = createRoot(domEl);

    const removeModal = () => {
        setTimeout(() => {
            root.unmount();
        }, 1000);
    };
    return new Promise((resolve) => {
        root.render(
            <ListSettingsModal
                onClose={removeModal}
                onUpdate={resolve}
                {...props}
            />,
        );
        allTrackers.trackEvent(
            "pop up/list model setting",
            "open",
            (props.list && props.list.friendlyName) || "create new list",
        );
    });
};

export const addToWatchlistModal = (domain: string): Promise<IOpportunityListItemTrackStatus> => {
    const domEl = document.createElement("div");
    document.body.appendChild(domEl);
    const root = createRoot(domEl);

    return new Promise((resolve, reject) => {
        let resolved = false;
        const onSelect = (args: IOpportunityListItemTrackStatus) => {
            allTrackers.dispatchTrackEvent("Button", "click", "add");
            resolved = true;
            resolve(args);
        };
        const removeModal = () => {
            setTimeout(() => {
                root.unmount();
            }, 1000);
            if (!resolved) {
                reject(new Error());
            }
        };
        root.render(
            <WatchListModal
                onClose={removeModal}
                onSelect={onSelect}
                domain={domain}
            />,
        );
    });
};
